<template>
  <div class="NewList_search_box" >
    <div class="NewList_search">
      <div class="tit" v-if="terminal == 'pc'">{{$t('NewList.Active')}}</div>
      <div class="tit mobile_tit" v-else>
        <div> <!-- {{$t('NewList.Active')}}--></div>
        <div @click="openFilter" class="filterbox">
          <i class="iconfont icon-guolv filterIcon"></i>
          {{$t('NewList.Filter')}}
          <div class="openFilterbox" :class="[showFilter?'activeFilterOpen':'activeFilterClose']">
            <i class="iconfont icon-xiangxia1"></i>
          </div>
        </div>
      </div>
      <div class="Search_box" v-if="terminal == 'pc'">
        <div class="select_box_date">
          <el-date-picker
            v-model="mouth"
            value-format="yyyy-MM"
            type="month"
            :placeholder="$t('NewList.Time')"
          ></el-date-picker>
        </div>
        <div class="select_box">
          <!-- <div class="select_box_label">
            <i class="iconfont icon-down"></i>
          </div>-->
          <el-select v-model="sdgId" :placeholder="$t('NewList.Goal')">
            <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="select_box">
          <div class="btn_ search_" @click="searchFunNew()">{{$t('NewList.Search')}}</div>
          <div class="btn_" @click="clearCondition()">{{$t('NewList.Reset')}}</div>
        </div>
      </div>
      <div v-else>
        <transition name="sub-search">
          <div class="mobileSearch" v-if="showFilter">
            <div class="mobileSearch_box">
              <!-- <div class="mobileSearch_tit_box">
            <div class="tit">新闻类型</div>
            <div class="selectTime borderStyle" @click="openType()"></div>
              </div>-->

              <div class="select_box_date"></div>
              <div class="mobileSearch_tit_box">
                <div class="tit">{{$t('NewList.Time')}}</div>
                <el-date-picker
                  v-model="mouth"
                  value-format="yyyy-MM"
                  type="month"
                  :placeholder="$t('NewList.Time')"
                ></el-date-picker>
              </div>

              <div class="mobileSearch_tit_box">
                <div class="tit">{{$t('NewList.Goal')}}</div>
                <el-select v-model="sdgId" :placeholder="$t('NewList.Goal')">
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="mobileSearch_btn">
                <div class="btn" @click="searchFunNew()">{{$t('NewList.Search')}}</div>
                <div class="btn" @click="clearCondition()">{{$t('NewList.Reset')}}</div>
                <!-- <div class="btn">关闭</div> -->
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
import { newsTarget, searchNews } from "@/axios/news.js";
import bus from "@/bus";
export default {
  mixins: [mapMixin],
  data() {
    return {
      showFilter: false,
      mouth: "",
      options: [],
      sdgId: ""
    };
  },
  mounted() {
    this.getNewsTarget();
  },

  watch: {
    $route(to, from) {
      this.mouth = "";
      this.sdgId = "";
    }
  },
  methods: {
    openFilter() {
      this.showFilter = !this.showFilter;
    },
    handleConfirm() {},

    onValuesChange(picker, values) {
      if (values[0] > values[1]) {
        picker.setSlotValue(1, values[0]);
      }
    },
    async getNewsTarget() {
      var res = await newsTarget();
      this.options = res.data.data;
    },
    searchFunNew() {
      var param = {};
      if (this.mouth) {
        param.mouth = this.mouth;
      }
      if (this.sdgId) {
        param.sdgId = this.sdgId;
      }
      console.log(param);
      bus.$emit("searchNewsEmit", param);
    },
    clearCondition() {
      this.mouth = "";
      this.sdgId = "";
      this.searchFunNew();
    }
  }
};
</script>

<style lang="scss">
@media screen and (min-width: 1026px) {
  .NewList_search_box {
    width: 100%;
    height: 220px;
    background: rgba(0, 104, 157, 1);
  }
  .NewList_search {
    width: 1200px;
    height: 80px;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .tit {
      font-size: 40px;
      color: #fff;
      margin-top: 24px;
      margin-bottom: 30px;
    }
    .Search_box {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .select_box_date {
        width: 380px;
        height: 40px;

        select {
          cursor: pointer;
          width: 100%;
          height: 100%;
          line-height: 40px;
          padding-right: 20px;
          text-indent: 4px;
          text-align: left;
          vertical-align: middle;
          border: 1px solid #94c1e7;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          font-family: SimHei;
          font-size: 18px;
          font-weight: 500;
          color: #000;
          cursor: pointer;
          outline: none;
        }
        option {
          height: 100px;
        }
        .el-select {
          width: 100%;
        }
        .el-input {
          width: 100%;
          margin-right: 30px;
        }
        .el-input__inner {
          border: none;
          border-radius: 4px;
          padding-left: 40px;
          font-size: 16px;
          color: #333;
          font-weight: 600;
        }
        .el-input__icon {
          font-size: 24px;
        }
        input::-webkit-input-placeholder {
          color: #000;
          font-size: 16px;
          font-weight: 600;
        }
      }
      .select_box {
        width: 380px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .btn_ {
          text-align: center;
          line-height: 40px;
          font-size: 18px;
          cursor: pointer;
          border-radius: 4px;
          width: 180px;
          color: rgba(0, 104, 157, 1);
          height: 40px;
          background: #fff;
          transition: 0.2s;
          &:hover {
            transition: 0.2s;
            opacity: 0.9;
          }
        }
        .search_ {
          margin-right: 10px;
        }
        select {
          cursor: pointer;
          width: 100%;
          height: 100%;
          line-height: 40px;
          padding-right: 20px;
          text-indent: 4px;
          text-align: left;
          vertical-align: middle;
          border: 1px solid #94c1e7;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          font-family: SimHei;
          font-size: 18px;
          font-weight: 500;
          color: #000;
          cursor: pointer;
          outline: none;
        }
        option {
          height: 100px;
        }
        .el-select {
          width: 100%;
        }
        .el-input {
          width: 100%;
          border-radius: 4px;
          margin-right: 30px;
        }
        .el-input__suffix {
          width: 30px;
          height: 30px;
          background: rgba(0, 104, 157, 1);
          border-radius: 50%;
          color: #fff;
          top: 5px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          .el-input__icon {
            color: #fff !important;
            font-size: 20px;
          }
        }
        .el-input__inner {
          border: none;
          border-radius: 4px;
          // border-bottom: 2px solid #dcdfe6;
          // padding-left: 40px;
          font-size: 16px;
          color: #333;
          font-weight: 600;
        }
        .el-input__icon {
          font-size: 24px;
        }
        input::-webkit-input-placeholder {
          color: #000;
          font-size: 16px;
          font-weight: 600;
        }
      }
    }

    .key {
      width: 300px;
      height: 40px;
      position: relative;
      i {
        position: absolute;
        left: 0;
        top: 6px;
        width: 30px;
        height: 30px;
        font-size: 24px;
        color: #c0c4cc;
      }
      input {
        height: 40px;
        width: 100%;
        padding-left: 40px;
        border-radius: 0;
        border: none;
        border-bottom: 2px solid #dcdfe6;
        font-size: 16px;
        color: #999;
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .NewList_search_box {
    width: 100%;
    height: 220px;
    background: rgba(0, 104, 157, 1);
  }
  .NewList_search {
    width: 1200px;
    height: 80px;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .tit {
      font-size: 40px;
      color: #fff;
      margin-top: 24px;
      margin-bottom: 30px;
    }
    .Search_box {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .select_box_date {
        width: 380px;
        height: 40px;

        select {
          cursor: pointer;
          width: 100%;
          height: 100%;
          line-height: 40px;
          padding-right: 20px;
          text-indent: 4px;
          text-align: left;
          vertical-align: middle;
          border: 1px solid #94c1e7;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          font-family: SimHei;
          font-size: 18px;
          font-weight: 500;
          color: #000;
          cursor: pointer;
          outline: none;
        }
        option {
          height: 100px;
        }
        .el-select {
          width: 100%;
        }
        .el-input {
          width: 100%;
          margin-right: 30px;
        }
        .el-input__inner {
          border: none;
          border-radius: 4px;
          padding-left: 40px;
          font-size: 16px;
          color: #333;
          font-weight: 600;
        }
        .el-input__icon {
          font-size: 24px;
        }
        input::-webkit-input-placeholder {
          color: #000;
          font-size: 16px;
          font-weight: 600;
        }
      }
      .select_box {
        width: 380px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .btn_ {
          text-align: center;
          line-height: 40px;
          font-size: 18px;
          cursor: pointer;
          border-radius: 4px;
          width: 180px;
          color: rgba(0, 104, 157, 1);
          height: 40px;
          background: #fff;
          transition: 0.2s;
          &:hover {
            transition: 0.2s;
            opacity: 0.9;
          }
        }
        .search_ {
          margin-right: 10px;
        }
        select {
          cursor: pointer;
          width: 100%;
          height: 100%;
          line-height: 40px;
          padding-right: 20px;
          text-indent: 4px;
          text-align: left;
          vertical-align: middle;
          border: 1px solid #94c1e7;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          font-family: SimHei;
          font-size: 18px;
          font-weight: 500;
          color: #000;
          cursor: pointer;
          outline: none;
        }
        option {
          height: 100px;
        }
        .el-select {
          width: 100%;
        }
        .el-input {
          width: 100%;
          border-radius: 4px;
          margin-right: 30px;
        }
        .el-input__suffix {
          width: 30px;
          height: 30px;
          background: rgba(0, 104, 157, 1);
          border-radius: 50%;
          color: #fff;
          top: 5px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          .el-input__icon {
            color: #fff !important;
            font-size: 20px;
          }
        }
        .el-input__inner {
          border: none;
          border-radius: 4px;
          // border-bottom: 2px solid #dcdfe6;
          // padding-left: 40px;
          font-size: 16px;
          color: #333;
          font-weight: 600;
        }
        .el-input__icon {
          font-size: 24px;
        }
        input::-webkit-input-placeholder {
          color: #000;
          font-size: 16px;
          font-weight: 600;
        }
      }
    }

    .key {
      width: 300px;
      height: 40px;
      position: relative;
      i {
        position: absolute;
        left: 0;
        top: 6px;
        width: 30px;
        height: 30px;
        font-size: 24px;
        color: #c0c4cc;
      }
      input {
        height: 40px;
        width: 100%;
        padding-left: 40px;
        border-radius: 0;
        border: none;
        border-bottom: 2px solid #dcdfe6;
        font-size: 16px;
        color: #999;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .mint-popup-bottom {
    width: 100%;
  }
  .picker-toolbar-title {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }

  .usi-btn-cancel,
  .usi-btn-sure {
    color: #ff6600;
  }

  .NewList_search {
    background: #fff;
    .mobile_tit {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 10px 20px;

      font-weight: 600;
      font-size: 16px;
      color: #333;
      .filterbox {
        display: flex;
        flex-direction: row;
        align-items: center;
        .filterIcon {
          margin-right: 4px;
        }
        .openFilterbox {
          margin-left: 10px;
        }
        .activeFilterOpen {
          transition: 0.2s;
          transform: rotate(0deg);
        }
        .activeFilterClose {
          transition: 0.2s;
          transform: rotate(-90deg);
        }
      }
    }
    .mobileSearch {
      display: flex;
      flex-direction: column;
      // padding: 20px 10px;
      .mobileSearch_box {
        padding: 20px 10px;
        height: 100%;
        background: rgba(238, 238, 238, 1);

        .mobileSearch_tit_box {
          // width: 100%;
          margin-top: 10px;
          .el-select {
            width: 100%;
          }
          .el-input {
            width: 100%;
          }
          .tit {
            margin-bottom: 6px;
            color: #000;
            font-size: 16px;
          }
          .borderStyle {
            height: 40px;
            width: 100%;
            border: 1px solid #d8d8d8;
            background: #fff;
            border-radius: 4px;
            margin-bottom: 10px;
          }
        }
        .mobileSearch_btn {
          display: flex;
          flex-direction: row;
          .btn {
            flex: 1;
            text-align: center;
            padding: 10px;
            background: rgba(0, 104, 157, 1);
            margin: 10px;
            color: #fff;
            border-radius: 4px;
          }
        }
      }
    }
  }
}



.sub-search-enter-active,
.sub-search-leave-active {
  transition: all 0.3s ease;
  height: 256px; /* 这里70px为menu-one子菜单的高度 */
}
.sub-search-enter,
.sub-search-leave-to {
  opacity: 0;
  height: 0px;
}
</style>